import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';
import type { DashboardAlert } from '../types/dashboard';
import { alertPath } from '../utils/dashboardPaths';

interface Props {
  alert: DashboardAlert;
  scope: string;
  scopeId: number;
}

export function personalInviteMessage(alert: DashboardAlert): string {
  if (alert.message) return alert.message;
  const count = alert.count ?? 1;
  return `You have ${count} invitation${count === 1 ? '' : 's'} waiting`;
}

const PersonalInviteNotice: React.FC<Props> = ({ alert, scope, scopeId }) => {
  const navigate = useNavigate();
  const path = alertPath(alert.type, scope, scopeId);

  return (
    <div className="dashboard-invite-notice" role="status">
      <FiMail size={18} className="flex-shrink-0" aria-hidden />
      <span className="dashboard-invite-notice__text min-w-0">{personalInviteMessage(alert)}</span>
      {path ? (
        <Button
          size="sm"
          variant="outline-primary"
          className="flex-shrink-0 text-nowrap"
          onClick={() => navigate(path)}
        >
          View
        </Button>
      ) : null}
    </div>
  );
};

export default PersonalInviteNotice;
